import * as yup from "yup";

import { removeHtmlTagsAndEntities } from "../utils";

export const emailRegex = /^[a-zA-Z0-9._%+!*-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export function createRequiredTrimmedString(message) {
  return yup.string().trim().required(message);
}

export function createEmailSchema({
  requiredMessage = "Email is required",
  invalidMessage = "Invalid email address",
} = {}) {
  return yup
    .string()
    .trim()
    .required(requiredMessage)
    .email(invalidMessage)
    .matches(emailRegex, invalidMessage);
}

export function createRichTextRequiredSchema(
  requiredMessage,
  emptyMessage = requiredMessage
) {
  return yup
    .string()
    .required(requiredMessage)
    .test("no-only-spaces", emptyMessage, (value = "") => {
      return removeHtmlTagsAndEntities(value).trim().length > 0;
    });
}

export function createImageFileSchema({
  maxSizeInKb = 200,
  unsupportedMessage = "Unsupported file format",
  sizeMessage = `File size exceeds ${maxSizeInKb}KB`,
} = {}) {
  return yup
    .mixed()
    .nullable()
    .test("fileType", unsupportedMessage, (value) => {
      if (!value) {
        return true;
      }

      return ["image/jpeg", "image/png"].includes(value.type);
    })
    .test("fileSize", sizeMessage, (value) => {
      if (!value) {
        return true;
      }

      return value.size <= maxSizeInKb * 1024;
    });
}

export function createPasswordFieldSchema(regexMap, requiredMessage) {
  return yup
    .string()
    .required(requiredMessage)
    .matches(regexMap.minMax, "Password must be between 8 and 128 characters")
    .matches(
      regexMap.uppercase,
      "Password must contain at least one uppercase letter"
    )
    .matches(
      regexMap.lowercase,
      "Password must contain at least one lowercase letter"
    )
    .matches(regexMap.number, "Password must contain at least one number");
}
